export default __webpack_public_path__ + "static/media/image.b965dc32.svg";